// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDGBdOlAmM29sTrCmXjAC_LWCurzJWZUCg",
  authDomain: "prayerwall-f2dfe.firebaseapp.com",
  projectId: "prayerwall-f2dfe",
  storageBucket: "prayerwall-f2dfe.firebasestorage.app",
  messagingSenderId: "445763223215",
  appId: "1:445763223215:web:c056e840cb183e3a405e5a"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize individual Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: 'select_account' });

// Export the app (optional)
export default app;
